module.exports = __webpack_public_path__ + "static/cfr-second-logo-2368e6a308db8d25e44fc1166c0ef3a5.jpg";